export const paginationStyles = {
  // Main container
  container: {
    w: '100%',
    overflowX: 'auto' as const,
  },

  // Flex wrapper
  wrapper: {
    direction: { base: 'column', md: 'row' } as any,
    justify: 'space-between' as const,
    align: { base: 'stretch', md: 'center' } as any,
    gap: 2,
  },

  // Left side container for "Show X Results"
  leftContainer: {
    spacing: 2,
    align: 'center' as const,
  },

  // "Show" and "Results" text
  labelText: {
    fontSize: '14px',
    color: '#4A5568',
    fontWeight: '400',
  },

  // Select dropdown for results per page
  select: {
    size: 'sm' as const,
    w: '65px',
    h: '32px',
    fontSize: '14px',
    fontWeight: '400',
    color: '#1A202C',
    bg: 'white',
    borderColor: '#E2E8F0',
    borderRadius: 'md',
    _hover: { 
      borderColor: '#CBD5E0',
    },
    _focus: { 
      borderColor: '#3182CE', 
      boxShadow: '0 0 0 1px #3182CE',
    },
  },

  // Scrollable button container
  buttonScrollContainer: {
    overflowX: 'auto' as const,
    w: { base: '100%', md: 'auto' },
  },

  // Scrollbar styles
  scrollbar: {
    '&::-webkit-scrollbar': {
      height: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '2px',
    },
  },

  // HStack for buttons
  buttonGroup: {
    spacing: 1,
    justify: { base: 'center', md: 'flex-end' } as any,
    minW: 'fit-content',
  },

  // Ellipsis box
  ellipsisBox: {
    px: 2,
    py: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minW: '32px',
    h: '32px',
  },

  // Ellipsis text
  ellipsisText: {
    fontSize: '14px',
    color: '#718096',
    fontWeight: '400',
  },

  // Base button styles
  button: {
    base: {
      size: 'sm' as const,
      minW: '32px',
      h: '32px',
      fontSize: '14px',
      fontWeight: '400',
      px: 2,
      borderRadius: 'md',
      transition: 'all 0.2s',
    },
  },

  // Navigation buttons (<- ->)
  navButton: {
    variant: 'outline' as const,
    bg: 'white',
    color: '#4A5568',
    borderColor: '#E2E8F0',
    _hover: {
      bg: '#F7FAFC',
      borderColor: '#CBD5E0',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
      _hover: {
        bg: 'white',
        borderColor: '#E2E8F0',
      },
    },
  },

  // Active button (current page)
  activeButton: {
    variant: 'solid' as const,
    bg: '#E53E3E',  // Chakra red.500
    color: 'white',
    border: 'none',
    fontWeight: '500',
    _hover: {
      bg: '#C53030',  // Chakra red.600
    },
  },

  // Inactive button (other pages)
  inactiveButton: {
    variant: 'outline' as const,
    bg: 'white',
    color: '#1A202C',
    borderColor: '#E2E8F0',
    _hover: {
      bg: '#F7FAFC',
      borderColor: '#CBD5E0',
    },
  },

  // Color values
  colors: {
    // Active button (current page)
    activeButtonBg: '#E53E3E',
    activeButtonHover: '#C53030',
    activeButtonColor: 'white',

    // Inactive button (other pages)
    inactiveButtonBg: 'white',
    inactiveButtonColor: '#1A202C',
    inactiveButtonBorder: '#E2E8F0',
    inactiveButtonHover: '#F7FAFC',

    // Navigation buttons
    navButtonColor: '#4A5568',
    navButtonBorder: '#E2E8F0',
    navButtonHover: '#F7FAFC',

    // Text
    labelText: '#4A5568',
    ellipsisColor: '#718096',

    // Scrollbar
    scrollbarThumb: '#CBD5E0',
    scrollbarThumbHover: '#A0AEC0',
  },
}

export const paginationColors = paginationStyles.colors
export const paginationButtonStyles = {
  active: paginationStyles.activeButton,
  inactive: paginationStyles.inactiveButton,
  nav: paginationStyles.navButton,
}